<template>
  <Loader v-if="isLoading"></Loader>
  <b-row v-else>
    <b-col cols="12">
      <router-link
              v-if="item"
              :to="{ name: 'AppConfiguration' }"
              class="btn btn-default float-right btn-sm mb-2">{{ $t('buttons.backToList') }}
      </router-link>
    </b-col>
    <b-col cols="12">
      <b-card>
        <i class="fa fa-user-lock fa-lg mr-2"></i>
        <span class="h6">{{ item['description'] }}</span>
        <hr class="mb-2 mt-1">
        <b-row v-if="item">
          <b-col>
            <template v-for="(confView, confViewIndex) in item.confViews">
              <b-row v-bind:key="'confView-' + confViewIndex">
                <b-col>
                  <!--<h6>{{ confView.description }}</h6>-->
                  <template v-for="(confComponent, confComponentIndex) in confView.confComponents">
                    <b-row v-bind:key="'confComponent-' + confComponentIndex">
                      <b-col v-if="confComponent">
                        <b-row>
                          <!--<b-col cols="1"><h5>#{{ confComponentIndex + 1 }}</h5></b-col>-->
                          <b-col>
                            <p>{{ confComponent.description }} <b-btn :to="{name: 'ConfAclUpdate', params: { id: confComponent.confAcls[0]['@id'] }}" size="sm">{{ $t('buttons.edit') }}</b-btn></p>
                            <Roles :confAcl="confComponent.confAcls[0]"></Roles>
                          </b-col>
                        </b-row>
                        <hr>
                      </b-col>
                    </b-row>
                  </template>
                </b-col>
              </b-row>
            </template>
          </b-col>
        </b-row>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Roles from './components/roles'
import Loader from '@/components/Dashboard/Layout/Loader'

export default {
  computed: mapGetters({
    deleteError: 'conftype/del/error',
    error: 'conftype/show/error',
    isLoading: 'conftype/show/isLoading',
    item: 'conftype/show/retrieved'
  }),

  components: {
    Roles,
    Loader
  },

  beforeDestroy () {
    this.reset()
  },

  created () {
    this.retrieve(decodeURIComponent(this.$route.params.id))
  },

  methods: {
    ...mapActions({
      del: 'conftype/del/del',
      reset: 'conftype/show/reset',
      retrieve: 'conftype/show/retrieve'
    }),

    async fetchClientTypes () {
    },

    deleteItem (item) {
      if (window.confirm('Are you sure you want to delete this item?')) {
        this.del(item).then(() => this.$router.push({ name: 'ConfTypeList' }))
      }
    }
  }
}
</script>
